import React, { useState, useEffect, useCallback } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import moment from "moment";
import config, { MARKETING } from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import Login from "../../Authentication/Login";
import MarketingTabs from "../AllTabs/MarketingTabs";

const LeadCalendar = () => {
  const { user, loading } = useAuth();
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const getLeadData = useCallback(
    async (viewInfo) => {
      if (!user || !viewInfo) return;
      try {
        const startDate = moment(viewInfo.start).toISOString();
        const endDate = moment(viewInfo.end).toISOString();
        const resourceUrl = `${config.GETLEADSFORCALENDAR}/${user.cid}?startDate=${startDate}&endDate=${endDate}`;
        const res = await apiService.getAll(resourceUrl);
        if (res) {
          const calendarEvents = res
            .filter((lead) => lead.callBack)
            .map((lead) => ({
              title: `${lead.name} - ${moment(lead.callBack).format(
                "DD-MMM-YYYY, hh:mm A"
              )}`,
              date: lead.callBack,
              extendedProps: { ...lead },
              // Add custom properties for styling
              className: "calendar-event", // Custom class for styling
            }));
          setEvents(calendarEvents);
        }
      } catch (error) {
        console.error("Error fetching lead data for calendar range:", error);
      }
    },
    [user]
  );

  const handleDatesSet = (viewInfo) => {
    getLeadData(viewInfo);
  };

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event.extendedProps);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  if (loading) return <p>Loading...</p>;
  if (!user) return <Login />;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <MarketingTabs pageName="APPOINTMENT"></MarketingTabs>
              </div>
              <div className="card-body">
                <div className="col-12 pb-2 fs-5">Appointments</div>
                {/* Add custom CSS for calendar events */}
                <style>
                  {`
                  /* Style for calendar events */
                  .calendar-event {
                    color: white !important;
                    cursor: pointer !important;
                  }
                  
                  /* Hover effect for calendar events */
                  .calendar-event:hover {
                    opacity: 0.8;
                  }
                  
                  /* Ensure pointer cursor on all interactive elements */
                  .fc-event {
                    cursor: pointer !important;
                  }
                  
                  /* Style for event content */
                  .fc-event-title {
                    color: white !important;
                  }
                  
                  /* Override any default styles that might affect text color */
                  .fc .fc-event {
                    color: white !important;
                  }
                  `}
                </style>
                <FullCalendar
                  plugins={[
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    bootstrap5Plugin,
                  ]}
                  themeSystem="bootstrap5"
                  headerToolbar={{
                    left: "today prev,next",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                  }}
                  buttonText={{
                    today: "Today",
                    month: "Month",
                    week: "Week",
                    day: "Day",
                    list: "Agenda",
                  }}
                  initialView="dayGridMonth"
                  height="75vh"
                  events={events}
                  datesSet={handleDatesSet}
                  eventClick={handleEventClick}
                  // Ensure events have the pointer cursor
                  eventClassNames="cursor-pointer"
                />
                {selectedEvent && (
                  <Modal show={showModal} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Callback Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p>
                        <strong>Name:</strong> {selectedEvent.name}
                      </p>
                      <p>
                        <strong>Phone:</strong> {selectedEvent.phoneNumber}
                      </p>
                      <p>
                        <strong>Email:</strong> {selectedEvent.email}
                      </p>
                      <p>
                        <strong>Status:</strong>{" "}
                        <span className="badge bg-info text-dark">
                          {selectedEvent.leadStatusName}
                        </span>
                      </p>
                      <p>
                        <strong>Callback Time:</strong>{" "}
                        {moment(selectedEvent.callBack).format(
                          "DD-MMM-YYYY, hh:mm A"
                        )}
                      </p>
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        className="btn btn-secondary"
                        onClick={handleCloseModal}
                      >
                        Close
                      </button>
                    </Modal.Footer>
                  </Modal>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadCalendar;
